import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft } from "lucide-react";
import LanguageSelector from "./LanguageSelector";
import BrowserBanner from "./BrowserBanner";
import { useLanguage } from "../i18n/LanguageContext";

export default function Layout({ children, showBack = false }) {
  const { t } = useLanguage();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="vls-app">
      <BrowserBanner />
      <header className="vls-header" data-testid="app-header">
        <Link to="/" className="vls-brand" data-testid="brand-link">
          <img
            src="/logo.png"
            alt="Velocity Lab System"
            className="vls-brand-logo"
          />
          <div className="vls-brand-text">
            <span className="vls-brand-name">VELOCITY LAB</span>
            <span className="vls-brand-sub">ELITE PERFORMANCE</span>
          </div>
        </Link>
        <div className="vls-header-actions">
          {!isHome && (
            <Link
              to="/"
              className="vls-icon-btn"
              aria-label={t("home")}
              data-testid="home-button"
            >
              {showBack ? <ArrowLeft size={18} /> : <HomeIcon size={18} />}
              <span className="vls-hide-sm">{showBack ? t("back") : t("home")}</span>
            </Link>
          )}
          <LanguageSelector />
        </div>
      </header>
      <main className="vls-main">{children}</main>
      <footer className="vls-footer">
        <span>© Velocity Lab System · Elite Global Performance Courses</span>
      </footer>
    </div>
  );
}
